module.exports = __webpack_public_path__ + "img/button_situation.b0dc8292.svg";